import { Buffer } from 'buffer';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { ApolloClient, InMemoryCache } from '@apollo/client';
import { Base64 } from 'js-base64';
import gql from 'graphql-tag';
import fetch from 'isomorphic-unfetch';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

// A type of promise-like that resolves synchronously and supports only one observer

const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))) : "@@iterator";

const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))) : "@@asyncIterator";

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
	try {
		var result = body();
	} catch(e) {
		return recover(e);
	}
	if (result && result.then) {
		return result.then(void 0, recover);
	}
	return result;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n  mutation resendUserAttributeVerificationCode(\n    $clientMetadata: ClientMetadataInput\n    $validationData: ValidationDataInput\n  ) {\n    resendUserAttributeVerificationCode(\n      clientMetadata: $clientMetadata\n      validationData: $validationData\n    ) {\n      statusCode\n      message\n    }\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n  mutation confirmSignUp(\n    $username: String!\n    $confirmationCode: String!\n    $clientMetadata: ClientMetadataInput\n    $validationData: ValidationDataInput\n  ) {\n    confirmSignUp(\n      username: $username\n      confirmationCode: $confirmationCode\n      clientMetadata: $clientMetadata\n      validationData: $validationData\n    ) {\n      statusCode\n      message\n    }\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n  mutation resendConfirmationCode(\n    $email: String!\n    $clientMetadata: ClientMetadataInput\n    $validationData: ValidationDataInput\n  ) {\n    resendConfirmationCode(\n      email: $email\n      clientMetadata: $clientMetadata\n      validationData: $validationData\n    ) {\n      statusCode\n      message\n    }\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n  mutation verifyUserAttribute(\n    $attributeName: String!\n    $code: String!\n    $clientMetadata: ClientMetadataInput\n    $validationData: ValidationDataInput\n  ) {\n    verifyUserAttribute(\n      attributeName: $attributeName\n      code: $code\n      clientMetadata: $clientMetadata\n      validationData: $validationData\n    ) {\n      statusCode\n      message\n    }\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n  mutation changePassword(\n    $previousPassword: String!\n    $newPassword: String!\n    $clientMetadata: ClientMetadataInput\n    $validationData: ValidationDataInput\n  ) {\n    changePassword(\n      previousPassword: $previousPassword\n      newPassword: $newPassword\n      clientMetadata: $clientMetadata\n      validationData: $validationData\n    ) {\n      statusCode\n      message\n    }\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  mutation confirmForgotPassword(\n    $confirmationCode: String!\n    $username: String!\n    $password: String!\n    $clientMetadata: ClientMetadataInput\n    $validationData: ValidationDataInput\n  ) {\n    confirmForgotPassword(\n      confirmationCode: $confirmationCode\n      username: $username\n      password: $password\n      clientMetadata: $clientMetadata\n      validationData: $validationData\n    ) {\n      statusCode\n      message\n    }\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  mutation forgotPassword(\n    $username: String!\n    $clientMetadata: ClientMetadataInput\n    $validationData: ValidationDataInput\n  ) {\n    forgotPassword(\n      username: $username\n      clientMetadata: $clientMetadata\n      validationData: $validationData\n    ) {\n      statusCode\n      message\n    }\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  mutation updateProfile(\n    $givenName: String\n    $familyName: String\n    $email: String\n    $marketingOptInWB: Boolean\n    $marketingOptInWW: Boolean\n    $books: [String]\n    $movies: [String]\n    $plays: [String]\n    $favorites: ProfileFavoritesInput\n    $pet: Pet\n  ) {\n    updateProfile(\n      givenName: $givenName\n      familyName: $familyName\n      email: $email\n      marketingOptInWB: $marketingOptInWB\n      marketingOptInWW: $marketingOptInWW\n      books: $books\n      movies: $movies\n      plays: $plays\n      favorites: $favorites\n      pet: $pet\n    ) {\n      id\n      givenName\n      familyName\n      email\n      emailVerified\n      birthdate\n      country\n      marketingOptInWB\n      marketingOptInWW\n      hogwartsHouse\n      ilvermornyHouse\n      wand {\n        core\n        flexibility\n        wood\n        length\n      }\n      patronus\n      patronusName\n      patronusFileName\n      isPottermoreUser\n      books\n      movies\n      plays\n      favorites {\n        character\n        spellOrPotion\n        placeOrTransport\n        beastOrBeing\n        quidditchPosition\n        objectOrFood\n      }\n      registeredOn\n      benefits {\n        wwid\n        benefitId\n      }\n      subscriptions {\n        type\n        status\n        subType\n        startDate\n        endDate\n        autoRenew\n        renewCount\n      }\n      underage\n      sortedViaApp\n      pet\n    }\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  mutation updateUserAttributes(\n    $givenName: String\n    $familyName: String\n    $email: String\n    $clientMetadata: ClientMetadataInput\n    $validationData: ValidationDataInput\n  ) {\n    updateUserAttributes(\n      givenName: $givenName\n      familyName: $familyName\n      email: $email\n      clientMetadata: $clientMetadata\n      validationData: $validationData\n    ) {\n      statusCode\n      message\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  mutation signUp(\n    $username: String!\n    $password: String!\n    $givenName: String!\n    $familyName: String!\n    $birthdate: String!\n    $locale: String!\n    $customAttributes: CustomAttributesInput\n    $clientMetadata: ClientMetadataInput\n    $validationData: ValidationDataInput\n  ) {\n    signUp(\n      username: $username\n      password: $password\n      givenName: $givenName\n      familyName: $familyName\n      birthdate: $birthdate\n      locale: $locale\n      customAttributes: $customAttributes\n      clientMetadata: $clientMetadata\n      validationData: $validationData\n    ) {\n      statusCode\n      message\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  mutation signOut($clientMetadata: ClientMetadataInput, $validationData: ValidationDataInput) {\n    signOut(clientMetadata: $clientMetadata, validationData: $validationData) {\n      statusCode\n      message\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  mutation signIn(\n    $username: String!\n    $password: String!\n    $clientMetadata: ClientMetadataInput\n    $validationData: ValidationDataInput\n  ) {\n    signIn(\n      username: $username\n      password: $password\n      clientMetadata: $clientMetadata\n      validationData: $validationData\n    ) {\n      statusCode\n      message\n      authenticationResult {\n        idToken\n        accessToken\n        refreshToken\n        expiresIn\n        tokenType\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  mutation refreshUserSession(\n    $refreshToken: String!\n    $accessToken: String!\n    $clientMetadata: ClientMetadataInput\n    $validationData: ValidationDataInput\n  ) {\n    refreshUserSession(\n      refreshToken: $refreshToken\n      accessToken: $accessToken\n      clientMetadata: $clientMetadata\n      validationData: $validationData\n    ) {\n      statusCode\n      message\n      authenticationResult {\n        idToken\n        accessToken\n        expiresIn\n        tokenType\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var AUTH_REFRESH_SESSION = gql(_templateObject());
var AUTH_SIGN_IN = gql(_templateObject2());
var AUTH_SIGN_OUT = gql(_templateObject3());
var AUTH_SIGN_UP = gql(_templateObject4());
var AUTH_UPDATE_USER_ATTRIBUTES = gql(_templateObject5());
var AUTH_UPDATE_PROFILE = gql(_templateObject6());
var AUTH_FORGOT_PASSWORD = gql(_templateObject7());
var AUTH_CONFIRM_FORGOT_PASSWORD = gql(_templateObject8());
var AUTH_CHANGE_PASSWORD = gql(_templateObject9());
var AUTH_VERIFY_USER_ATTRIBUTE = gql(_templateObject10());
var AUTH_RESEND_CONFIRMATION_CODE = gql(_templateObject11());
var AUTH_CONFIRM_SIGN_UP = gql(_templateObject12());
var AUTH_RESEND_ATTRIBUTE_VERIFICATION_CODE = gql(_templateObject13());

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  query getUserInfo($clientMetadata: ClientMetadataInput, $validationData: ValidationDataInput) {\n    getUserInfo(clientMetadata: $clientMetadata, validationData: $validationData) {\n      statusCode\n      message\n      userInfo {\n        verified\n        emailVerified\n        givenName\n        familyName\n        country\n        wwid\n      }\n    }\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var AUTH_CURRENT_USER_INFO = gql(_templateObject$1());

var onetrustGroupActive = function onetrustGroupActive(groupID) {
  if (groupID === void 0) {
    groupID = '201';
  }

  var currentActiveGroups = (window.dataLayer || []).map(function (dl) {
    return (dl || {}).OnetrustActiveGroups;
  }).filter(function (dl) {
    return dl;
  }).pop() || '';
  return currentActiveGroups.split(',').includes(groupID);
};
var googleTagManagerHelpers = {
  onetrustGroupActive: onetrustGroupActive
};

var INTERVAL_DELAY = 15000;
var trackedPermissions = {};
var intervalCheck = {
  running: null
};
var canSetPACookie = function canSetPACookie() {
  return onetrustGroupActive('201');
};
var canSetPerformanceCookie = function canSetPerformanceCookie() {
  return onetrustGroupActive('pf') || onetrustGroupActive('2');
};
var canSetTargetingCookie = function canSetTargetingCookie() {
  return onetrustGroupActive('tc') || onetrustGroupActive('4');
};
var dispatch = function dispatch(permissionName, data) {
  (trackedPermissions[permissionName] || []).forEach(function (cb) {
    return cb(data);
  });
  delete trackedPermissions[permissionName];

  if (Object.keys(trackedPermissions).length === 0) {
    clearInterval(intervalCheck.running);
    intervalCheck.running = null;
  }
};
var checkPermissionChanges = function checkPermissionChanges() {
  if (trackedPermissions.canSetPACookie) {
    var permissionVal = canSetPACookie();

    if (permissionVal) {
      dispatch('canSetPACookie', permissionVal);
    }
  } else if (trackedPermissions.canSetPerformanceCookie) {
    var _permissionVal = canSetPerformanceCookie();

    if (_permissionVal) {
      dispatch('canSetPerformanceCookie', _permissionVal);
    }
  } else if (trackedPermissions.canSetTargetingCookie) {
    var _permissionVal2 = canSetTargetingCookie();

    if (_permissionVal2) {
      dispatch('canSetTargetingCookie', _permissionVal2);
    }
  }
};
var onPermissionChange = function onPermissionChange(functionName, cb) {
  if (!trackedPermissions[functionName]) {
    trackedPermissions[functionName] = [];
  }

  trackedPermissions[functionName].push(cb);

  if (!intervalCheck.running) {
    intervalCheck.running = setInterval(checkPermissionChanges, INTERVAL_DELAY);
  }
};

var permissions = {
  __proto__: null,
  INTERVAL_DELAY: INTERVAL_DELAY,
  trackedPermissions: trackedPermissions,
  intervalCheck: intervalCheck,
  canSetPACookie: canSetPACookie,
  canSetPerformanceCookie: canSetPerformanceCookie,
  canSetTargetingCookie: canSetTargetingCookie,
  dispatch: dispatch,
  checkPermissionChanges: checkPermissionChanges,
  onPermissionChange: onPermissionChange
};

var PERFORMANCE_ADVERTISING_COOKIES = ['ww_registered', 'utm_campaign', 'utm_content', 'utm_medium', 'utm_term', 'utm_source', 'utm_name', 'resetAnalytics'];
var PERFORMANCE_COOKIES = ['_CEFT', '_ga', '_gat', '_gid', 'ajs_anonymous_id'];
var TARGETING_COOKIES = ['userAnalyticsIntegrationsTrait'];

var isPACookie = function isPACookie(cookieName) {
  return PERFORMANCE_ADVERTISING_COOKIES.includes(cookieName);
};

var isPerformanceCookie = function isPerformanceCookie(cookieName) {
  return PERFORMANCE_COOKIES.includes(cookieName);
};

var isTargetingCookie = function isTargetingCookie(cookieName) {
  return TARGETING_COOKIES.includes(cookieName);
};

var isomorphicSetCookie = function isomorphicSetCookie(res, cookie) {
  if (res && res.setHeader && res.getHeader) {
    var cookies = res.getHeader('Set-Cookie') || [];
    if (typeof cookies === 'string') cookies = [cookies];
    if (typeof cookies === 'number') cookies = [];
    var cookieName = cookie.split('=')[0];
    var cookiesToSet = cookies.filter(function (c) {
      return !c.includes(cookieName + "=");
    });
    cookiesToSet.push(cookie);
    res.setHeader('Set-Cookie', cookiesToSet);
  } else if (process.browser) {
    document.cookie = cookie;
  }
};
var setCookie = function setCookie(options, res) {
  var name = options.name,
      _options$value = options.value,
      value = _options$value === void 0 ? '' : _options$value,
      _options$expires = options.expires,
      expires = _options$expires === void 0 ? 0 : _options$expires,
      _options$isSecure = options.isSecure,
      isSecure = _options$isSecure === void 0 ? false : _options$isSecure;
  var domain = process.env.NODE_ENV === 'development' ? 'localhost' : process.env.REACT_APP_DOMAIN;
  var secure = '';
  if (isSecure) secure = 'secure;';
  var expiration = typeof expires === 'string' ? expires : new Date(Date.now() + expires).toUTCString();
  var cookie = name + "=" + value + ";expires=" + expiration + ";domain=" + domain + ";path=/;" + secure;

  if (isPACookie(name) && !canSetPACookie()) {
    onPermissionChange('canSetPACookie', function () {
      isomorphicSetCookie(null, cookie);
    });
  } else if (isTargetingCookie(name) && !canSetTargetingCookie()) {
    onPermissionChange('canSetTargetingCookie', function () {
      isomorphicSetCookie(null, cookie);
    });
  } else if (isPerformanceCookie(name) && !canSetPerformanceCookie()) {
    onPermissionChange('canSetPerformanceCookie', function () {
      isomorphicSetCookie(null, cookie);
    });
  } else {
    isomorphicSetCookie(res, cookie);
  }
};
var isomorphicGetCookies = function isomorphicGetCookies(req) {
  if (req && req.headers && req.headers.cookie) {
    return req.headers.cookie;
  }

  if (process.browser) {
    return document.cookie;
  }

  return '';
};
var getCookie = function getCookie(name, req) {
  var cookies = isomorphicGetCookies(req);
  var cookie = cookies.split(';').map(function (c) {
    return c.trim();
  }).filter(function (c) {
    return !!c;
  }).find(function (c) {
    return c.startsWith(name + "=");
  });
  return cookie ? cookie.split('=').slice(1).join('=') : null;
};
var eraseCookie = function eraseCookie(name, res) {
  var domain = process.env.NODE_ENV === 'development' ? 'localhost' : process.env.REACT_APP_DOMAIN;
  var cookie = name + "=;domain=" + domain + ";path=/;Max-Age=-99999999;Expires=Thu, 01 Jan 1970 00:00:00 GMT;";
  isomorphicSetCookie(res, cookie);
};

var cookie = {
  __proto__: null,
  isomorphicSetCookie: isomorphicSetCookie,
  setCookie: setCookie,
  isomorphicGetCookies: isomorphicGetCookies,
  getCookie: getCookie,
  eraseCookie: eraseCookie
};

var SERVER_USER_AGENT = 'next-js-server';

var AuthError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(AuthError, _Error);

  function AuthError(message, code, name, statusCode) {
    var _this;

    _this = _Error.call(this, message) || this;
    _this.code = code;
    _this.name = name;
    _this.statusCode = statusCode;
    return _this;
  }

  return AuthError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var name = "wizarding-world-web-shared";
var version = "0.12.2";
var description = "Shared code for the wizarding world web applications";
var author = "mattpwalsh";
var license = "none";
var repository = "pmfawkes/wizarding-world-web-shared";
var main = "dist/index.js";
var module = "dist/index.modern.js";
var source = "src/index.js";
var engines = {
	node: ">=12"
};
var scripts = {
	build: "microbundle-crl --no-compress --format modern,cjs",
	start: "microbundle-crl watch --no-compress --format modern,cjs",
	prepare: "run-s build",
	test: "run-s test:coverage test:lint test:build",
	"test:build": "run-s build",
	"test:lint": "eslint src/",
	"test:unit": "cross-env CI=1 react-scripts test --env=jsdom --colors",
	"test:coverage": "cross-env CI=1 react-scripts test --env=jsdom --colors --coverage",
	"test:watch": "react-scripts test --env=jsdom --colors"
};
var peerDependencies = {
	react: "^16.0.0"
};
var devDependencies = {
	"babel-eslint": "^10.0.3",
	"cross-env": "^7.0.2",
	enzyme: "^3.11.0",
	"enzyme-adapter-react-16": "^1.15.5",
	eslint: "^6.8.0",
	"eslint-config-airbnb": "^18.2.0",
	"eslint-config-prettier": "^6.11.0",
	"eslint-config-standard": "^14.1.0",
	"eslint-config-standard-react": "^9.2.0",
	"eslint-plugin-es5": "^1.5.0",
	"eslint-plugin-import": "^2.22.0",
	"eslint-plugin-jsx-a11y": "^6.3.1",
	"eslint-plugin-node": "^11.0.0",
	"eslint-plugin-prettier": "^3.1.4",
	"eslint-plugin-promise": "^4.2.1",
	"eslint-plugin-react": "^7.20.6",
	"eslint-plugin-react-hooks": "^4.1.2",
	"eslint-plugin-standard": "^4.0.1",
	"gh-pages": "^2.2.0",
	"microbundle-crl": "^0.13.10",
	"npm-run-all": "^4.1.5",
	prettier: "^2.0.4",
	react: "^16.13.1",
	"react-dom": "^16.13.1",
	"react-scripts": "^3.4.1",
	"react-test-renderer": "^16.13.1"
};
var files = [
	"dist"
];
var dependencies = {
	"@apollo/client": "^3.2.5",
	"apollo-link-context": "^1.0.20",
	"apollo-link-http": "^1.5.17",
	buffer: "^5.6.0",
	graphql: "^15.3.0",
	"graphql-tag": "^2.11.0",
	"isomorphic-unfetch": "^3.1.0",
	"js-base64": "^3.7.2"
};
var jest = {
	coverageThreshold: {
		global: {
			branches: 100,
			functions: 100,
			lines: 100,
			statements: 100
		}
	}
};
var packageJSON = {
	name: name,
	version: version,
	description: description,
	author: author,
	license: license,
	repository: repository,
	main: main,
	module: module,
	source: source,
	engines: engines,
	scripts: scripts,
	peerDependencies: peerDependencies,
	devDependencies: devDependencies,
	files: files,
	dependencies: dependencies,
	jest: jest
};

var AuthClass = /*#__PURE__*/function () {
  function AuthClass() {
    var _this = this;

    this.getClientMetadata = function () {
      return {
        platform: getCookie('wwClientName') || 'WEB',
        version: packageJSON.version
      };
    };

    this.throwAuthError = function (error) {
      if (!error.code) {
        throw new AuthError('Unhandled error', 'UnhandledError', '', 5000);
      }

      throw error;
    };

    this.keyPrefix = "CognitoIdentityServiceProvider." + process.env.REACT_APP_USER_POOL_WEBCLIENTID;
    this.appKeyPrefix = "CognitoIdentityServiceProvider." + process.env.REACT_APP_USER_POOL_APPCLIENTID;
    this.cookiesSecure = process.env.NODE_ENV !== 'development';
    this.cookiesDuration = 365 * 24 * 60 * 60 * 1000;
    this.accessTokenRequiredOps = ['changePassword', 'refreshUserSession', 'verifyUserAttribute', 'resendUserAttributeVerificationCode'];
    this.statusCodes = {
      2000: 'Success',
      2100: 'Created',
      4000: 'InvalidParameterException',
      4001: 'UsernameExistsException',
      4002: 'UserLambdaValidationException',
      4100: 'NotAuthorizedException',
      4101: 'ExpiredAccessToken',
      4102: 'CodeMismatchException',
      4200: 'UserNotConfirmedException',
      5300: 'LimitExceededException',
      5000: 'UnhandledError'
    };
    var httpLink = createHttpLink({
      uri: "" + process.env.REACT_APP_FEDERATED_API
    });

    this.authLink = function (request, _ref) {
      var headers = _ref.headers;

      try {
        var _temp4 = function _temp4() {
          return {
            headers: _extends({}, headers, !process.browser ? {
              'User-Agent': SERVER_USER_AGENT
            } : {}, {
              Authorization: authString
            })
          };
        };

        var authString = 'none';

        var _temp5 = _catch(function () {
          var _temp = function () {
            if (request.operationName !== 'refreshUserSession') {
              return Promise.resolve(_this.currentSession()).then(function (session) {
                var bearerToken = process.env.REACT_APP_AUTH_ID_TOKEN_ENABLED === 'TRUE' ? session.idToken.token : session.accessToken.token;

                if (_this.accessTokenRequiredOps.includes(request.operationName)) {
                  bearerToken = session.accessToken.token;
                }

                authString = "Bearer " + bearerToken;
              });
            }
          }();

          if (_temp && _temp.then) return _temp.then(function () {});
        }, function () {});

        return Promise.resolve(_temp5 && _temp5.then ? _temp5.then(_temp4) : _temp4(_temp5));
      } catch (e) {
        return Promise.reject(e);
      }
    };

    this.AuthAPI = new ApolloClient({
      link: setContext(this.authLink).concat(httpLink),
      cache: new InMemoryCache()
    });
  }

  var _proto = AuthClass.prototype;

  _proto.checkStatusCode = function checkStatusCode(responseData) {
    if (![2100, 2000].includes(responseData.statusCode)) {
      throw new AuthError(responseData.message, this.statusCodes[responseData.statusCode], '', responseData.statusCode);
    }
  };

  _proto.currentSession = function currentSession() {
    try {
      var _this3 = this;

      var user = _this3.getUserFromStorage();

      if (!user) {
        throw new Error('No logged in user.');
      }

      return Promise.resolve(_catch(function () {
        return Promise.resolve(_this3.userSession(user));
      }, function () {
        return null;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getUserFromStorage = function getUserFromStorage() {
    var clientName = getCookie('wwClientName') || 'WEB';
    var clientKeyPrefix = this.keyPrefix;

    if (clientName === 'ANDROID' || clientName === 'IOS') {
      clientKeyPrefix = this.appKeyPrefix;
    }

    var lastAuthUser = getCookie(clientKeyPrefix + ".LastAuthUser");

    if (lastAuthUser) {
      return {
        username: lastAuthUser,
        userKey: encodeURIComponent(clientKeyPrefix + "." + lastAuthUser),
        userDataKey: encodeURIComponent(clientKeyPrefix + "." + lastAuthUser + ".userData")
      };
    }

    return null;
  };

  _proto.userSession = function userSession(user) {
    try {
      var _temp10 = function _temp10(_result) {
        var _exit2 = false;
        if (_exit3) return _result;

        function _temp7(_result2) {
          return _exit2 ? _result2 : {};
        }

        var _temp6 = _catch(function () {
          return Promise.resolve(_this5.refreshSession(cachedSession.refreshToken.token, cachedSession.accessToken.token)).then(function (refreshData) {
            setCookie({
              name: accessTokenKey,
              value: refreshData.accessToken,
              expires: _this5.cookiesDuration,
              isSecure: _this5.cookiesSecure
            });
            setCookie({
              name: idTokenKey,
              value: refreshData.idToken,
              expires: _this5.cookiesDuration,
              isSecure: _this5.cookiesSecure
            });
            _exit2 = true;
            return {
              accessToken: {
                token: refreshData.accessToken,
                payload: decode(refreshData.accessToken)
              },
              refreshToken: {
                token: cachedSession.refreshToken.token
              },
              idToken: {
                token: refreshData.idToken,
                payload: decode(refreshData.idToken)
              }
            };
          });
        }, function () {
          return Promise.resolve(_this5.signOut(false)).then(function () {});
        });

        return _temp6 && _temp6.then ? _temp6.then(_temp7) : _temp7(_temp6);
      };

      var _exit3 = false;

      var _this5 = this;

      if (!user) {
        throw new Error('Invalid user.');
      }

      var keyPrefix = user.userKey;
      var accessTokenKey = keyPrefix + ".accessToken";
      var refreshTokenKey = keyPrefix + ".refreshToken";
      var idTokenKey = keyPrefix + ".idToken";

      var isSessionValid = function isSessionValid(session) {
        if (!session.accessToken.token || !session.refreshToken.token || !session.idToken.token) {
          return false;
        }

        var now = Math.floor(new Date() / 1000);
        return now < session.accessToken.payload.exp && now < session.idToken.payload.exp;
      };

      var decode = function decode(token) {
        if (!token) return {};
        var payload = token.split('.')[1];

        try {
          return JSON.parse(Buffer.from(payload, 'base64').toString('utf8'));
        } catch (err) {
          return {};
        }
      };

      var cachedSession = {
        accessToken: {
          token: getCookie(accessTokenKey) || '',
          payload: decode(getCookie(accessTokenKey))
        },
        refreshToken: {
          token: getCookie(refreshTokenKey) || ''
        },
        idToken: {
          token: getCookie(idTokenKey) || '',
          payload: decode(getCookie(idTokenKey))
        }
      };

      if (isSessionValid(cachedSession)) {
        return Promise.resolve(cachedSession);
      }

      var _temp11 = function () {
        if (!cachedSession.refreshToken.token) {
          return Promise.resolve(_this5.signOut(false)).then(function () {
            _exit3 = true;
            return {};
          });
        }
      }();

      return Promise.resolve(_temp11 && _temp11.then ? _temp11.then(_temp10) : _temp10(_temp11));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.refreshSession = function refreshSession(refreshToken, accessToken) {
    try {
      var _this7 = this;

      return Promise.resolve(_this7.AuthAPI.mutate({
        mutation: AUTH_REFRESH_SESSION,
        variables: {
          refreshToken: refreshToken,
          accessToken: accessToken,
          clientMetadata: _this7.getClientMetadata()
        }
      }).then(function (response) {
        return response;
      })["catch"](function () {
        return {};
      })).then(function (_ref2) {
        var data = _ref2.data;

        if (!data) {
          throw new AuthError('Unhandled error', 'UnhandledError', '', 5000);
        }

        return data.refreshUserSession.authenticationResult;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.currentUserInfo = function currentUserInfo(bypassCache) {
    if (bypassCache === void 0) {
      bypassCache = false;
    }

    try {
      var _this9 = this;

      var user = _this9.getUserFromStorage();

      if (!user) {
        return Promise.resolve(null);
      }

      if (!bypassCache) {
        try {
          var userData = JSON.parse(Base64.decode(getCookie(user.userKey + ".userData")));
          return Promise.resolve(userData);
        } catch (e) {}
      }

      return Promise.resolve(_this9.AuthAPI.query({
        query: AUTH_CURRENT_USER_INFO,
        variables: {
          clientMetadata: _this9.getClientMetadata()
        }
      }).then(function (response) {
        return response;
      })).then(function (_ref3) {
        var _data$getUserInfo, _data$getUserInfo$use, _data$getUserInfo2, _data$getUserInfo2$us, _data$getUserInfo3, _data$getUserInfo3$us, _data$getUserInfo4, _data$getUserInfo4$us, _data$getUserInfo5;

        var data = _ref3.data;

        if (!data) {
          return null;
        }

        var userData = {
          attributes: _extends({
            email: user.username,
            given_name: (data === null || data === void 0 ? void 0 : (_data$getUserInfo = data.getUserInfo) === null || _data$getUserInfo === void 0 ? void 0 : (_data$getUserInfo$use = _data$getUserInfo.userInfo) === null || _data$getUserInfo$use === void 0 ? void 0 : _data$getUserInfo$use.givenName) || '',
            family_name: (data === null || data === void 0 ? void 0 : (_data$getUserInfo2 = data.getUserInfo) === null || _data$getUserInfo2 === void 0 ? void 0 : (_data$getUserInfo2$us = _data$getUserInfo2.userInfo) === null || _data$getUserInfo2$us === void 0 ? void 0 : _data$getUserInfo2$us.familyName) || '',
            email_verified: (data === null || data === void 0 ? void 0 : (_data$getUserInfo3 = data.getUserInfo) === null || _data$getUserInfo3 === void 0 ? void 0 : (_data$getUserInfo3$us = _data$getUserInfo3.userInfo) === null || _data$getUserInfo3$us === void 0 ? void 0 : _data$getUserInfo3$us.emailVerified) || false,
            verified: (data === null || data === void 0 ? void 0 : (_data$getUserInfo4 = data.getUserInfo) === null || _data$getUserInfo4 === void 0 ? void 0 : (_data$getUserInfo4$us = _data$getUserInfo4.userInfo) === null || _data$getUserInfo4$us === void 0 ? void 0 : _data$getUserInfo4$us.verified) || false
          }, data === null || data === void 0 ? void 0 : (_data$getUserInfo5 = data.getUserInfo) === null || _data$getUserInfo5 === void 0 ? void 0 : _data$getUserInfo5.userInfo)
        };
        setCookie({
          name: user.userKey + ".userData",
          value: Base64.encode(JSON.stringify(userData)),
          expires: _this9.cookiesDuration,
          isSecure: _this9.cookiesSecure
        });
        return userData;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.currentAuthenticatedUser = function currentAuthenticatedUser() {
    try {
      var _this11 = this;

      var user = _this11.getUserFromStorage();

      return Promise.resolve(_this11.currentUserInfo()).then(function (userInfo) {
        var attributes = userInfo.attributes;
        Object.assign(user, {
          attributes: attributes
        });
        return user;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.updateUserAttributes = function updateUserAttributes(user, attributes) {
    try {
      var _this13 = this;

      if (!user) {
        return Promise.resolve();
      }

      return Promise.resolve(_this13.AuthAPI.mutate({
        mutation: AUTH_UPDATE_USER_ATTRIBUTES,
        variables: _extends({
          clientMetadata: _this13.getClientMetadata()
        }, attributes)
      }).then(function (response) {
        try {
          _this13.checkStatusCode(response.data.updateUserAttributes);

          return Promise.resolve(_this13.currentUserInfo(true)).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      })["catch"](function (error) {
        _this13.throwAuthError(error);
      })).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.updateProfile = function updateProfile(user, attributes) {
    try {
      var _this15 = this;

      if (!user) {
        return Promise.resolve();
      }

      return Promise.resolve(_this15.AuthAPI.mutate({
        mutation: AUTH_UPDATE_PROFILE,
        variables: _extends({}, attributes)
      }).then(function () {
        try {
          return Promise.resolve(_this15.currentUserInfo(true)).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      })["catch"](function (error) {
        _this15.throwAuthError(error);
      })).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.verifyCurrentUserAttributeSubmit = function verifyCurrentUserAttributeSubmit(attributeName, code) {
    try {
      var _this17 = this;

      var user = _this17.getUserFromStorage();

      if (!user) {
        return Promise.resolve();
      }

      return Promise.resolve(_this17.AuthAPI.mutate({
        mutation: AUTH_VERIFY_USER_ATTRIBUTE,
        variables: {
          attributeName: attributeName,
          code: code,
          clientMetadata: _this17.getClientMetadata()
        }
      }).then(function (response) {
        _this17.checkStatusCode(response.data.verifyUserAttribute);
      })["catch"](function (error) {
        _this17.throwAuthError(error);
      })).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.signUp = function signUp(params) {
    try {
      var _this19 = this;

      var validationData = {
        reCaptchaVersion: 'v3',
        reCaptchaToken: null
      };

      if (params.reCaptchaToken) {
        validationData.reCaptchaToken = params.reCaptchaToken;
      }

      return Promise.resolve(_this19.AuthAPI.mutate({
        mutation: AUTH_SIGN_UP,
        variables: {
          username: params.username,
          password: params.password,
          givenName: params.attributes.given_name,
          familyName: params.attributes.family_name,
          birthdate: params.attributes.birthdate,
          locale: params.attributes.locale || 'en',
          customAttributes: {
            registrationSource: params.attributes['custom:registrationSource'],
            utmCampaign: params.attributes.utmCampaign
          },
          clientMetadata: _this19.getClientMetadata(),
          validationData: validationData
        }
      }).then(function (response) {
        _this19.checkStatusCode(response.data.signUp);
      })["catch"](function (error) {
        _this19.throwAuthError(error);
      })).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.resendEmailVerificationCode = function resendEmailVerificationCode() {
    try {
      var _this21 = this;

      var user = _this21.getUserFromStorage();

      if (!user) {
        return Promise.resolve();
      }

      return Promise.resolve(_this21.AuthAPI.mutate({
        mutation: AUTH_RESEND_ATTRIBUTE_VERIFICATION_CODE,
        variables: {
          clientMetadata: _this21.getClientMetadata()
        }
      }).then(function (response) {
        _this21.checkStatusCode(response.data.resendUserAttributeVerificationCode);
      })["catch"](function (error) {
        _this21.throwAuthError(error);
      })).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.confirmSignUp = function confirmSignUp(username, confirmationCode) {
    try {
      var _this23 = this;

      if (!username) {
        throw new AuthError('Missing email', 'InvalidParameterException', '', 4000);
      }

      if (!confirmationCode) {
        throw new AuthError('Missing confirmation code', 'InvalidParameterException', '', 4000);
      }

      return Promise.resolve(_this23.AuthAPI.mutate({
        mutation: AUTH_CONFIRM_SIGN_UP,
        variables: {
          username: username,
          confirmationCode: confirmationCode,
          clientMetadata: _this23.getClientMetadata()
        }
      }).then(function (response) {
        _this23.checkStatusCode(response.data.confirmSignUp);
      })["catch"](function (error) {
        _this23.throwAuthError(error);
      })).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.resendSignUp = function resendSignUp(email) {
    try {
      var _this25 = this;

      if (!email) {
        throw new Error('Email is invalid.');
      }

      return Promise.resolve(_this25.AuthAPI.mutate({
        mutation: AUTH_RESEND_CONFIRMATION_CODE,
        variables: {
          email: email,
          clientMetadata: _this25.getClientMetadata()
        }
      }).then(function (response) {
        _this25.checkStatusCode(response.data.resendConfirmationCode);
      })["catch"](function (error) {
        _this25.throwAuthError(error);
      })).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.signIn = function signIn(username, password) {
    try {
      var _this27 = this;

      return Promise.resolve(_this27.AuthAPI.mutate({
        mutation: AUTH_SIGN_IN,
        variables: {
          username: username,
          password: password,
          clientMetadata: _this27.getClientMetadata()
        }
      }).then(function (response) {
        _this27.checkStatusCode(response.data.signIn);

        var userKey = _this27.keyPrefix + "." + username;
        var authResult = response.data.signIn.authenticationResult;
        setCookie({
          name: _this27.keyPrefix + ".LastAuthUser",
          value: username,
          expires: _this27.cookiesDuration,
          isSecure: _this27.cookiesSecure
        });
        setCookie({
          name: encodeURIComponent(userKey + ".refreshToken"),
          value: authResult.refreshToken,
          expires: _this27.cookiesDuration,
          isSecure: _this27.cookiesSecure
        });
        setCookie({
          name: encodeURIComponent(userKey + ".accessToken"),
          value: authResult.accessToken,
          expires: _this27.cookiesDuration,
          isSecure: _this27.cookiesSecure
        });
        setCookie({
          name: encodeURIComponent(userKey + ".idToken"),
          value: authResult.idToken,
          expires: _this27.cookiesDuration,
          isSecure: _this27.cookiesSecure
        });
        setCookie({
          name: 'wwLoggedIn',
          value: true,
          expires: _this27.cookiesDuration,
          isSecure: _this27.cookiesSecure
        });
        setCookie({
          name: 'wwClientName',
          value: 'WEB',
          expires: _this27.cookiesDuration,
          isSecure: _this27.cookiesSecure
        });
      })["catch"](function (error) {
        _this27.throwAuthError(error);
      })).then(function () {
        return Promise.resolve(_this27.currentUserInfo(true)).then(function () {});
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.serverTokenSignIn = function serverTokenSignIn(username, accessToken, refreshToken, client, req, res) {
    var _this28 = this,
        _client,
        _client2;

    if (client === void 0) {
      client = 'web';
    }

    if (!username || !accessToken || !refreshToken) {
      return false;
    }

    if (req) {
      try {
        req.headers.cookie.split(';').map(function (c) {
          return c.trim();
        }).filter(function (c) {
          return !!c;
        }).filter(function (c) {
          return c.startsWith("" + _this28.keyPrefix) || c.startsWith("" + _this28.appKeyPrefix);
        }).forEach(function (cookieName) {
          eraseCookie(cookieName, res);
        });
      } catch (_unused) {}
    }

    var clientName = ['web', 'android', 'ios'].includes((_client = client) === null || _client === void 0 ? void 0 : _client.toLowerCase()) ? (_client2 = client) === null || _client2 === void 0 ? void 0 : _client2.toLowerCase() : 'web';
    var clientKeyPrefix = this.keyPrefix;

    if (clientName === 'android' || clientName === 'ios') {
      clientKeyPrefix = this.appKeyPrefix;
    }

    var userKey = clientKeyPrefix + "." + username;
    setCookie({
      name: clientKeyPrefix + ".LastAuthUser",
      value: username,
      expires: this.cookiesDuration,
      isSecure: this.cookiesSecure
    }, res);
    setCookie({
      name: encodeURIComponent(userKey + ".refreshToken"),
      value: refreshToken,
      expires: this.cookiesDuration,
      isSecure: this.cookiesSecure
    }, res);
    setCookie({
      name: encodeURIComponent(userKey + ".accessToken"),
      value: accessToken,
      expires: this.cookiesDuration,
      isSecure: this.cookiesSecure
    }, res);
    setCookie({
      name: "wwClientName",
      value: clientName.toUpperCase(),
      expires: this.cookiesDuration,
      isSecure: this.cookiesSecure
    }, res);
    setCookie({
      name: 'wwLoggedIn',
      value: true,
      expires: this.cookiesDuration,
      isSecure: this.cookiesSecure
    }, res);
    return true;
  };

  _proto.signOut = function signOut(invalidateSession) {
    if (invalidateSession === void 0) {
      invalidateSession = true;
    }

    try {
      var _temp14 = function _temp14() {
        eraseCookie(_this30.keyPrefix + ".LastAuthUser");
        eraseCookie(_this30.appKeyPrefix + ".LastAuthUser");
        eraseCookie(user.userKey + ".refreshToken");
        eraseCookie(user.userKey + ".accessToken");
        eraseCookie(user.userKey + ".clockDrift");
        eraseCookie(user.userKey + ".idToken");
        eraseCookie(user.userKey + ".userData");
        eraseCookie('wwClientName');
        setCookie({
          name: 'wwLoggedIn',
          value: false,
          expires: _this30.cookiesDuration,
          isSecure: _this30.cookiesSecure
        });
      };

      var _this30 = this;

      var user = _this30.getUserFromStorage();

      if (!user) {
        return Promise.resolve();
      }

      var _temp15 = function () {
        if (invalidateSession) {
          return Promise.resolve(_this30.AuthAPI.mutate({
            mutation: AUTH_SIGN_OUT,
            variables: {
              clientMetadata: _this30.getClientMetadata()
            }
          })["catch"](function (error) {
            _this30.throwAuthError(error);
          })).then(function () {});
        }
      }();

      return Promise.resolve(_temp15 && _temp15.then ? _temp15.then(_temp14) : _temp14(_temp15));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.changePassword = function changePassword(previousPassword, newPassword) {
    try {
      var _this32 = this;

      return Promise.resolve(_this32.AuthAPI.mutate({
        mutation: AUTH_CHANGE_PASSWORD,
        variables: {
          previousPassword: previousPassword,
          newPassword: newPassword,
          clientMetadata: _this32.getClientMetadata()
        }
      }).then(function (response) {
        _this32.checkStatusCode(response.data.changePassword);
      })["catch"](function (error) {
        _this32.throwAuthError(error);
      })).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.forgotPassword = function forgotPassword(username) {
    try {
      var _this34 = this;

      if (!username) {
        return Promise.resolve();
      }

      return Promise.resolve(_this34.AuthAPI.mutate({
        mutation: AUTH_FORGOT_PASSWORD,
        variables: {
          username: username,
          clientMetadata: _this34.getClientMetadata()
        }
      }).then(function (response) {
        _this34.checkStatusCode(response.data.forgotPassword);
      })["catch"](function (error) {
        _this34.throwAuthError(error);
      })).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.forgotPasswordSubmit = function forgotPasswordSubmit(username, confirmationCode, password) {
    try {
      var _this36 = this;

      if (!username) {
        throw new AuthError('Missing email', 'InvalidParameterException', '', 4000);
      }

      if (!confirmationCode) {
        throw new AuthError('Missing confirmation code', 'InvalidParameterException', '', 4000);
      }

      if (!password) {
        throw new AuthError('Missing password', 'InvalidParameterException', '', 4000);
      }

      return Promise.resolve(_this36.AuthAPI.mutate({
        mutation: AUTH_CONFIRM_FORGOT_PASSWORD,
        variables: {
          username: username,
          password: password,
          confirmationCode: confirmationCode,
          clientMetadata: _this36.getClientMetadata()
        }
      }).then(function (response) {
        _this36.checkStatusCode(response.data.confirmForgotPassword);
      })["catch"](function (error) {
        _this36.throwAuthError(error);
      })).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return AuthClass;
}();

var Auth = new AuthClass();

if (!process.browser) {
  global.fetch = fetch;
}

var ACCESS_TOKEN_REQUIRED_OPS = ['deleteAccount'];
var internalApiTested = false;
var useInternalApi = false;
var apolloClient = null;
var getHttpEndpoint = function getHttpEndpoint() {
  return useInternalApi ? "" + process.env.REACT_APP_INTERNAL_FEDERATED_API : "" + process.env.REACT_APP_FEDERATED_API;
};
var httpLink = createHttpLink({
  uri: getHttpEndpoint
});
var internalApiLink = function internalApiLink(_, context) {
  try {
    var _temp4 = function () {
      if (!process.browser && !internalApiTested) {
        var _temp5 = function _temp5() {
          internalApiTested = true;
        };

        var _temp6 = _catch(function () {
          return Promise.resolve(fetch("" + process.env.REACT_APP_INTERNAL_FEDERATED_API, {
            method: 'POST',
            headers: {
              authorization: 'none'
            },
            body: '{"query":"{health}"}'
          })).then(function (response) {
            useInternalApi = response.status === 200;
          });
        }, function () {
          useInternalApi = false;
        });

        return _temp6 && _temp6.then ? _temp6.then(_temp5) : _temp5(_temp6);
      }
    }();

    return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(function () {
      return context;
    }) : context);
  } catch (e) {
    return Promise.reject(e);
  }
};
var authLink = function authLink(request, _ref) {
  var headers = _ref.headers;

  try {
    var _temp10 = function _temp10() {
      var newHeaders = _extends({}, headers, !process.browser ? {
        'User-Agent': SERVER_USER_AGENT
      } : {}, {
        Authorization: Authorization
      });

      if (process.env.MARATHON_LOWERENV_ACCESS && !process.browser) {
        newHeaders['X-Marathon-LowerEnv-Access'] = process.env.MARATHON_LOWERENV_ACCESS;
      }

      return {
        headers: newHeaders
      };
    };

    var Authorization = 'none';

    var _temp11 = function () {
      if (process.browser) {
        var _temp12 = _catch(function () {
          return Promise.resolve(Auth.currentSession()).then(function (session) {
            var bearerToken = process.env.REACT_APP_AUTH_ID_TOKEN_ENABLED === 'TRUE' ? session.idToken.token : session.accessToken.token;

            if (ACCESS_TOKEN_REQUIRED_OPS.includes(request.operationName)) {
              bearerToken = session.accessToken.token;
            }

            Authorization = "Bearer " + bearerToken;
          });
        }, function () {});

        if (_temp12 && _temp12.then) return _temp12.then(function () {});
      }
    }();

    return Promise.resolve(_temp11 && _temp11.then ? _temp11.then(_temp10) : _temp10(_temp11));
  } catch (e) {
    return Promise.reject(e);
  }
};
var create = function create(initialState) {
  var authLinkContext = setContext(authLink);
  var internalApiLinkContext = setContext(internalApiLink);
  return new ApolloClient({
    connectToDevTools: process.browser,
    ssrMode: !process.browser,
    link: authLinkContext.concat(internalApiLinkContext).concat(httpLink),
    cache: new InMemoryCache().restore(initialState || {})
  });
};

var wizardingWorldAPI = function wizardingWorldAPI(initialState) {
  if (!process.browser) {
    return create(initialState);
  }

  if (!apolloClient) {
    apolloClient = create(initialState);
  }

  return apolloClient;
};

var services = {
  auth: Auth,
  api: wizardingWorldAPI
};

var utils = {
  cookie: cookie,
  googleTagManagerHelpers: googleTagManagerHelpers,
  permissions: permissions
};

var index = {
  services: services,
  utils: utils
};

export default index;
//# sourceMappingURL=index.modern.js.map
